import React from 'react';

/**
 * PageSkeleton — full-viewport fallback for lazy-loaded routes.
 * Mimics the warm-paper background and centers a subtle, low-key
 * brand-mark so users never see a blank flash while a chunk streams in.
 */
const PageSkeleton = () => (
  <div
    className="min-h-screen w-full bg-bone flex items-center justify-center"
    data-testid="page-skeleton"
    aria-busy="true"
    aria-live="polite"
  >
    <div className="font-serif text-mute italic text-sm tracking-wide animate-pulse">
      Norvig
    </div>
  </div>
);

export default PageSkeleton;
